import React, { ComponentType } from 'react';
import { Route, Redirect, RouteComponentProps, RouteProps } from 'react-router-dom';
import { AuthContext, AuthContextType } from '~/services';

interface ProtectedRouteProps extends Omit<RouteProps, 'component'> {
    component: ComponentType<RouteComponentProps>;
}

// Type assertions for TypeScript 5.x compatibility with react-router-dom v5
const RouteComponent = Route as any;
const RedirectComponent = Redirect as any;

export function ProtectedRoute({ component: Component, ...rest }: ProtectedRouteProps) {
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    return (
        <RouteComponent
            {...rest}
            render={(props: RouteComponentProps) =>
                authenticated === true ? (
                    <Component {...props} />
                ) : (
                    <RedirectComponent
                        to={{
                            pathname: '/',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
}
